import { render } from "./gtrPointsDetail.vue?vue&type=template&id=965ea118&ts=true"
import script from "./gtrPointsDetail.vue?vue&type=script&lang=ts"
export * from "./gtrPointsDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__